import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { GetCashRegisterDeviceChallengeResponseDto } from './dtos/get-cash-register-device-challenge.response.dto';
import { RegisterCashRegisterDeviceRequestDto } from './dtos/register-cash-register-device.request.dto';
import { VerifyCashRegisterDeviceRequestDto } from './dtos/verify-cash-register-device.request.dto';
import { VerifyCashRegisterDeviceResponseDto } from './dtos/verify-cash-register-device.response.dto';
import { environment } from '@orderna/admin-panel/src/environments/environment';
import { SuccessResponse } from '../../shared/success-response';
import { FindCashRegisterDeviceResponseDto } from './dtos/find-cash-register-device-response.dto';
import { GetCashRegisterDeviceChallengeRequestDto } from './dtos/get-cash-register-device-challenge.request.dto';

@Injectable({
  providedIn: 'root',
})
export class CashRegisterDeviceApiService {
  private http = inject(HttpClient);

  private readonly API_URL =
    `${environment.api}/cash-drawers/:cashRegisterId/device`;

  async getChallenge(
    cashRegisterId: number,
    dto: GetCashRegisterDeviceChallengeRequestDto,
  ): Promise<GetCashRegisterDeviceChallengeResponseDto> {
    const response = await firstValueFrom(
      this.http.post<
        SuccessResponse<GetCashRegisterDeviceChallengeResponseDto>
      >(
        `${this.API_URL.replace(':cashRegisterId', cashRegisterId.toString())}/challenge`,
        dto,
      ),
    );

    return response.data;
  }

  async getDevice(
    cashRegisterId: number,
  ): Promise<FindCashRegisterDeviceResponseDto> {
    const response = await firstValueFrom(
      this.http.get<
        SuccessResponse<FindCashRegisterDeviceResponseDto>
      >(
        `${this.API_URL.replace(':cashRegisterId', cashRegisterId.toString())}`,
      ),
    );

    return response.data;
  }

  async verify(
    cashRegisterId: number,
    body: VerifyCashRegisterDeviceRequestDto,
  ): Promise<VerifyCashRegisterDeviceResponseDto> {
    const response = await firstValueFrom(
      this.http.post<
        SuccessResponse<VerifyCashRegisterDeviceResponseDto>
      >(
        `${this.API_URL.replace(':cashRegisterId', cashRegisterId.toString())}/verify`,
        body,
      ),
    );

    return response.data;
  }

  async register(
    cashRegisterId: number,
    body: RegisterCashRegisterDeviceRequestDto,
  ): Promise<void> {
    await firstValueFrom(
      this.http.post(
        this.API_URL.replace(':cashRegisterId', cashRegisterId.toString()),
        body,
      ),
    );
  }
}